import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const RussiaPage = () => {
  return <DestinationTemplate destinationId="russia" />;
};

export default RussiaPage;
